import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import useAnalytics from '../hooks/useAnalytics';

interface TrackedButtonProps extends ButtonProps {
  trackingName: string;
  trackingCategory: string;
  trackingData?: Record<string, string | number | boolean>;
}

const TrackedButton: React.FC<TrackedButtonProps> = ({
  trackingName,
  trackingCategory,
  trackingData = {},
  onClick,
  children,
  ...buttonProps
}) => {
  const { trackCustomEvent } = useAnalytics();
  
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    // Track the click event
    trackCustomEvent('button_click', {
      name: trackingName,
      category: trackingCategory,
      ...trackingData,
      timestamp: Date.now()
    });
    
    // Call the original onClick handler if provided
    if (onClick) {
      onClick(event);
    }
  };
  
  return (
    <Button
      onClick={handleClick}
      {...buttonProps}
    >
      {children}
    </Button>
  );
};

export default TrackedButton; 